export default __webpack_public_path__ + "static/media/attendance.6bc808bd.svg";